<template>
    <div class="freightDialog">
        <el-dialog class="g-dialog" width="780px" :visible.sync="freightModal.visible" title="运费" @close="close">
            <div class="freight-content">
                <div class="lable-item">
                    <div class="item">
                        <span class="lable-title">运费详情模版：</span>
                        <el-select v-model="freightInfo.currentTemplate" placeholder="请选择" @change="templateChange">
                            <el-option v-for="item in freightTemplateOptions" :key="item._id" :label="item.newExpressName"
                                :value="item._id">
                            </el-option>
                        </el-select>
                    </div>
                    <div class="item">
                        <span class="lable-title">计算类型：</span>
                        <span class="text">{{ freightInfo.calculationTypeValue }}</span>
                    </div>
                    <div class="item">
                        <span class="lable-title">满额包邮：</span>
                        <span class="text" v-if="freightInfo.freeShippingMinPayment != '99999999'">订单商品金额满{{ freightInfo.freeShippingMinPayment }}元包邮</span>
                        <span class="text" v-else>暂无</span>
                    </div>
                    <div class="item">
                        <div class="table-title">通用设置</div>
                        <div class="freight-table">
                            <el-table :data="freightInfo.generalSettingList" style="width: 100%">
                                <el-table-column
                                    v-for="item in getCloumn"
                                    :key="item.prop"
                                    :prop="item.prop"
                                    :label="item.label"
                                    :width="item.width"
                                    :align="item.align"
                                    stripe
                                    highlight-current-row
                                >
                                    <template slot-scope="{ row }">
                                        <span v-if="item.prop == 'currency'">全国地区通用</span>
                                        <span v-else-if="item.prop == 'range'">
                                            {{ row.lowerLimit }}kg
                                            <span>~{{ row.upperLimit == '-1' ? '以上': `${row.upperLimit}kg` }}</span>
                                        </span>
                                        <span v-else-if="item.prop == 'rangeRecordNum'">
                                            {{ row.lowerLimit }}件
                                            <span>~{{ row.upperLimit == '-1' ? '以上': `${row.upperLimit}件` }}</span>
                                        </span>
                                        <span v-else-if="item.prop == 'volMinCost'" class="table-tag">{{ row.volMinCost }}</span>
                                        <span v-else-if="item.prop == 'cost'" class="table-tag">{{ row.cost }}</span>
                                        <span v-else>{{ row[item.prop] }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="item">
                        <div class="table-title">例外地区</div>
                        <div class="freight-table">
                            <el-table :data="freightInfo.exceptionalRegionList" style="width: 100%">
                                <el-table-column
                                    v-for="item in getCloumn"
                                    :key="item.prop"
                                    :prop="item.prop"
                                    :label="item.label"
                                    :width="item.width"
                                    :align="item.align"
                                    :show-overflow-tooltip="true"
                                    stripe
                                    highlight-current-row
                                >
                                    <template slot-scope="{ row }">
                                        <span v-if="item.prop == 'currency'">
                                            {{ row.cities }}</span>
                                        <span v-else-if="item.prop == 'range'">
                                            {{ row.lowerLimit }}kg
                                            <span>~{{ row.upperLimit == '-1' ? '以上': `${row.upperLimit}kg` }}</span>
                                        </span>
                                        <span v-else-if="item.prop == 'rangeRecordNum'">
                                            {{ row.lowerLimit }}件
                                            <span>~{{ row.upperLimit == '-1' ? '以上': `${row.upperLimit}件` }}</span>
                                        </span>
                                        <span v-else-if="item.prop == 'volMinCost'" class="table-tag">{{ row.volMinCost }}</span>
                                        <span v-else-if="item.prop == 'cost'" class="table-tag">{{ row.cost }}</span>
                                        <span v-else>{{ row[item.prop] }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapActions, mapState } from '../../../../store'
export default {
    components: {
    },
    data () {
        return {
            freightTemplateOptions: [],
            freightInfo: {
                currentTemplate: null,
                generalSettingList: [],
                exceptionalRegionList: [],
                calculationTypeValue: '按重量计算',
                freeShippingMinPayment:'',
            },
        };
    },
    computed: {
        ...mapState(["freightModal"]),
        getCloumn () {
            let cloumn = [];
            let calculationTypeValue =this.freightInfo.calculationTypeValue
            if (calculationTypeValue == '按重量计算') {
                //重量
                cloumn = [
                    {
                        prop: 'currency',
                        label: '运送地区范围',
                        align: 'left',
                    }, {
                        prop: 'range',
                        label: '阶梯区间（KG）',
                        width: '150',
                        align: 'left',
                    }, {
                        prop: 'weight',
                        label: '首重',
                        align: 'center',
                    }, {
                        prop: 'cost',
                        label: '首费（元）',
                        align: 'center',
                    }, {
                        prop: 'overWeight',
                        label: '每续重（KG）',
                        width: '100',
                        align: 'center',
                    }, {
                        prop: 'overCost',
                        label: '续费（元）',
                        align: 'center',
                    },
                ];
            } else if(calculationTypeValue == '按体积计算') {
                cloumn = [
                    {
                        prop: 'currency',
                        label: '运送地区范围',
                        align: 'left',
                    }, {
                        prop: 'volCost',
                        label: '运费单价(元/m³)',
                        width: '150',
                        align: 'center',
                    }, {
                        prop: 'volMinCost',
                        label: '最低费用',
                        width: '150',
                        align: 'center',
                    }, {
                        prop: 'volAddCost',
                        label: '附加费用',
                        width: '150',
                        align: 'center',
                    }, 
                ];
            }else if(calculationTypeValue == '按件计算'){
                cloumn = [
                    {
                        prop: 'currency',
                        label: '运送地区范围',
                        align: 'left',
                    }, {
                        prop: 'rangeRecordNum',
                        label: '阶梯区间(件)',
                        width: '150',
                        align: 'center',
                    }, {
                        prop: 'firstCost',
                        label: '第一件(元)',
                        width: '150',
                        align: 'center',
                    }, {
                        prop: 'anotherCostAnyNum',
                        label: '每多一件(元)',
                        width: '150',
                        align: 'center',
                    }, 
                ];
            }else if(calculationTypeValue == '按单计算'){
                cloumn = [
                    {
                        prop: 'currency',
                        label: '运送地区范围',
                        align: 'left',
                    }, {
                        prop: 'anyOrderCost',
                        label: '运费单价(元/单)',
                        width: '300',
                        align: 'center',
                    }
                ];
            }
            return cloumn;
        },
    },
    methods: {
        ...mapActions(["updateFreightModalParams"]),
        close () {
            this.updateFreightModalParams({
                visible: false,
            });
            this.freightInfo = {
                currentTemplate: null,
                generalSettingList: [],
                exceptionalRegionList: [],
                calculationTypeValue: '',
                freeShippingMinPayment: '',
            };
        },
        templateChange (value) {
            console.log(value);
            const filterInfo = this.freightModal.matchFreightRuleList.filter(item => {
                let id = item.dmsFreightRuleList[0].id;
                return id == value;
            }) || {};
            const currentTemplateInfo = filterInfo[0].dmsFreightRuleList[0] || {};
            this.setTableData(currentTemplateInfo);
        },
        setTableData (info = {}) {
            let generalSettingList = [];
            let exceptionalRegionList = [];
            let weightStrategyOrVolumeStrategyTable = [];
            this.freightInfo.freeShippingMinPayment = info.freeShippingMinPayment;
            if (info.calculateType == '1') {
                //按照重量计算
                weightStrategyOrVolumeStrategyTable = typeof info.weightStrategy == 'string' ? JSON.parse(info.weightStrategy) : info.weightStrategy;
                weightStrategyOrVolumeStrategyTable.forEach(item => {
                    if (item.isDefault) {
                        generalSettingList = item.subWeightStrategyList;
                    } else {
                        //例外区域会有多个 isDefault：0 需要做聚合
                        const arr = item.subWeightStrategyList || [];
                        arr.forEach(element => {
                            element.cities = item.cities.map(city => city.cityName).join(',');
                        });
                        exceptionalRegionList = [...exceptionalRegionList, ...arr];
                    }
                });
                this.freightInfo.calculationTypeValue = '按重量计算';
            } else if (info.calculateType == '2') {
                //按照体积计算
                weightStrategyOrVolumeStrategyTable = typeof info.volumeStrategy == 'string' ? JSON.parse(info.volumeStrategy) : info.volumeStrategy;
                weightStrategyOrVolumeStrategyTable.forEach(item => {
                    if (item.isDefault) {
                        generalSettingList = [...generalSettingList, item];
                    } else {
                        //例外区域会有多个 isDefault：0 需要做聚合
                        item.cities = item.cities.map(city => city.cityName).join(',');
                        exceptionalRegionList = [...exceptionalRegionList, item];

                    }
                });
                this.freightInfo.calculationTypeValue = '按体积计算';
            }else if(info.calculateType == '3'){
                //按件计算
                weightStrategyOrVolumeStrategyTable = typeof info.recordNumStrategy == 'string' ? JSON.parse(info.recordNumStrategy) : info.recordNumStrategy;
                weightStrategyOrVolumeStrategyTable.forEach(item => {
                    if (item.isDefault) {
                        generalSettingList = item.subNumStrategyList;
                    } else {
                        //例外区域会有多个 isDefault：0 需要做聚合
                        const arr = item.subNumStrategyList || [];
                        arr.forEach(element => {
                            element.cities = item.cities.map(city => city.cityName).join(',');
                        });
                        exceptionalRegionList = [...exceptionalRegionList, ...arr];
                    }
                });
                this.freightInfo.calculationTypeValue = '按件计算';
            }else if(info.calculateType == '4'){
                //按单计算
                weightStrategyOrVolumeStrategyTable = typeof info.orderStrategy == 'string' ? JSON.parse(info.orderStrategy) : info.orderStrategy;
                weightStrategyOrVolumeStrategyTable.forEach(item => {
                    if (item.isDefault) {
                        generalSettingList = [item];
                    } else {
                        //例外区域会有多个 isDefault：0 需要做聚合
                        item.cities = item.cities.map(city => city.cityName).join(',');
                        exceptionalRegionList = [...exceptionalRegionList, item];
                    }
                });
                this.freightInfo.calculationTypeValue = '按单计算';
            }
            this.$set(this.freightInfo, 'exceptionalRegionList', exceptionalRegionList);
            this.$set(this.freightInfo, 'generalSettingList', generalSettingList);

        },
        initData (list = []) {
            const arr = list.map(item => {
                item.newExpressName = `${ item.expressName }-${ item.dmsFreightRuleList[0].ruleName }`;
                item._id =item.dmsFreightRuleList[0].id
                return item;
            });
            this.freightTemplateOptions = arr;
            this.freightInfo.currentTemplate = arr[0]?._id;// 模版详情 暂时取第一个值
            const currentTemplateInfo = arr[0].dmsFreightRuleList[0] || {};
            this.setTableData(currentTemplateInfo);
        }
    },
    watch: {
        freightModal: {
            handler (val, oldVal) {
                if (val.visible && !oldVal.visible) {
                    this.initData(val.matchFreightRuleList);
                }
            },
            deep: true,
        },
    }
};
</script>

<style lang="scss" scoped>
.freightDialog {}

.freight-content {
    .lable-item{
        .item{
            margin-bottom: 20px;
            .table-title,
            .lable-title{
                display: inline-block;
                width: 100px;
                text-align: right;
                font-weight: 800;
            }
            .table-title{
                text-align: left;
                margin-bottom: 20px;
            }
            .text{

            }
            .freight-table{
                .table-tag{
                    display: inline-block;
                    background:#2695fa;
                    border-radius: 10px;
                    color: #fff;
                    line-height: 26px;
                    width: 100%;
                }
            }
        }
    }
}
</style>